import css from './MediaSourcePreview.module.scss';

interface MediaSourcePreviewProps {
  /** 'Channel', 'Playlist', 'File', or any label */
  label: string;
  /** Circular avatar (for channels) or rectangular thumbnail (for files/playlists) */
  image?: string;
  /** Use circular avatar style (channels) vs rectangular thumbnail (files) */
  circular?: boolean;
  title: string;
  subtitle?: string;
}

export const MediaSourcePreview = ({
  label,
  image,
  circular = false,
  title,
  subtitle,
}: MediaSourcePreviewProps) => {
  return (
    <div className={css.container} aria-label={label}>
      {image && (
        <div
          className={circular ? css.avatar : css.thumbnail}
          style={{ backgroundImage: `url(${image})` }}
        />
      )}
      <div className={css.info}>
        <div className={css.title}>{title}</div>
        {subtitle && <div className={css.subtitle}>{subtitle}</div>}
      </div>
    </div>
  );
};
